import { useCoreTheme } from "@/context/coreTheme";
import type { ButtonColor } from "@/constants/button";
import { getButtonIcon, getButtonStyles, type Icon } from "./utils";

export function useButtonStartIcon(
  color: ButtonColor,
  icon?: Icon,
): Icon | null {
  const { buttonSettings } = useCoreTheme();

  if (icon) return icon;

  const { icon: coreIcon, iconPosition } = getButtonStyles(
    color,
    buttonSettings,
  );

  if (iconPosition === "RIGHT") return null;

  return getButtonIcon(coreIcon);
}

export function useButtonEndIcon(color: ButtonColor, icon?: Icon): Icon | null {
  const { buttonSettings } = useCoreTheme();

  if (icon) return icon;

  const { icon: coreIcon, iconPosition } = getButtonStyles(
    color,
    buttonSettings,
  );

  if (iconPosition === "LEFT") return null;

  return getButtonIcon(coreIcon);
}
